<template>
  <!-- 底部 -->
  <div class="media-768-footer">
    <div >
      <div>Principal Investigator | Jin BAO</div>
      <div>
        Shenzhen Institute of Advanced Technology, Chinese Academy of Science
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "mediaFooter",
  data() {
    return {
      value1: "",
    };
  },
  methods: {},
  watch: {},
};
</script>


<style scoped>
@media screen and (max-width: 768px) {
  /* 底部字体样式 */
 a {
    text-decoration: none;
    color: #000;
 }
  .media-768-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    box-shadow: 0 1px 10px -6px rgba(0, 0, 0, 0.8);
    height: 60px;
  }

  .media-768-footer > div > div {
    width: 100%;
    text-align: center;
    font-size: 9px;
    color: #03305a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/media/mediaFooter.vue